var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        visible: _vm.dialogVisible,
        width: "912px",
        title: "附件列表",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c(
              "el-upload",
              {
                staticClass: "upload-demo",
                attrs: {
                  action: `/api/SystemFile/uploadFile?source=12&summaryId=${_vm.rowData.id}`,
                  data: { source: 12, summaryId: _vm.rowData.id },
                  headers: _vm.headers,
                  "on-success": _vm.handleSuccess,
                  "before-upload": _vm.beforeUpload,
                  "show-file-list": false,
                },
              },
              [
                _c("div", { staticClass: "upload flex_c_c" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/bill/upload-1.png"),
                      alt: "",
                    },
                  }),
                  _vm._v(" 选择文件上传 "),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "data" },
          [
            _c("BaseTable", {
              attrs: {
                tableData: _vm.tableData,
                height: "360",
                boreder: true,
                isPager: false,
              },
              scopedSlots: _vm._u([
                {
                  key: "opt",
                  fn: function (row) {
                    return _c("div", { staticClass: "optbtn" }, [
                      _c(
                        "div",
                        {
                          staticClass: "btn",
                          on: {
                            click: function ($event) {
                              return _vm.deleteRow(row.scope)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-delete" }),
                          _vm._v("删除 "),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "btn",
                          on: {
                            click: function ($event) {
                              return _vm.check(row.scope)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-zoom-in" }),
                          _vm._v("查看 "),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "btn",
                          on: {
                            click: function ($event) {
                              return _vm.download(row.scope)
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/bill/download.png"),
                              alt: "",
                            },
                          }),
                          _vm._v("下载 "),
                        ]
                      ),
                    ])
                  },
                },
              ]),
            }),
            _c("div", { staticClass: "footer" }, [
              _vm._v("*暂时只支持图片和PDF查看"),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }